import { datadogRum } from "@datadog/browser-rum";
import {
  nextjsPlugin,
  onRouterTransitionStart,
} from "@datadog/browser-rum-nextjs";
import getEnv from "@workspace/nextjs_utils/src/getEnv";

export { onRouterTransitionStart };

const getRuntimeEnv = (name: string) => {
  return getEnv(name);
};

const initDatadogRum = () => {
  const applicationId = getRuntimeEnv("DD_RUM_APPLICATION_ID");
  const clientToken = getRuntimeEnv("DD_RUM_CLIENT_TOKEN");

  if (!applicationId || !clientToken) {
    return false;
  }

  if (datadogRum.getInitConfiguration()) {
    return true;
  }

  datadogRum.init({
    applicationId,
    clientToken,
    site: "datadoghq.eu",
    service: getRuntimeEnv("DD_SERVICE") ?? "casino_frontend",
    env: getRuntimeEnv("DD_ENV") ?? "dev",
    version: getRuntimeEnv("VERSION") ?? "unknown",
    sessionSampleRate: 10,
    sessionReplaySampleRate: 0,
    traceSampleRate: 10,
    traceContextInjection: "sampled",
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    plugins: [nextjsPlugin()],
    allowedTracingUrls: [
      {
        match: getRuntimeEnv("GRAPHQL_CLIENT_URL") ?? "/graphql",
        propagatorTypes: ["tracecontext", "datadog"],
      },
    ],
  });

  return true;
};

const initialized = initDatadogRum();

if (!initialized && typeof window !== "undefined") {
  window.addEventListener(
    "load",
    () => {
      initDatadogRum();
    },
    { once: true },
  );
}
